export default "__VITE_ASSET__be759b59__"